// extracted by mini-css-extract-plugin
var _1 = "UserAvatarGroup-moduleUserAvatarGroup__q8iFK";
var _2 = "UserAvatarGroup-moduleavatar__zZiq8";
var _3 = "UserAvatarGroup-modulemore__LAAWV UserAvatarGroup-moduleavatar__zZiq8";
var _4 = "UserAvatarGroup-modulemoreText__OaTyo Avatar-moduletext__JenMw";
export { _1 as "UserAvatarGroup", _2 as "avatar", _3 as "more", _4 as "moreText" }
